<div
  style="
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: auto;
    background-image: url('/apps/signup_bg.svg');
    background-size: cover;
  "
>
  <div style="margin-top: 5%; padding: 10px; text-align: center" *ngIf="app">
    <div>
      <img [src]="'/apps/' + app + '/splash.png'" width="180" align="center" />
    </div>
    <div class="form">
      <form [formGroup]="form">
        <div class="title">{{ _common.SignUpNow }}</div>
        <div style="color: #f26822">
          <fa-icon icon="chevron-circle-down"></fa-icon>
        </div>

        <div
          style="
            color: red;
            font-size: smaller;
            margin-top: 2em;
            margin-bottom: 1em;
          "
          *ngIf="error"
        >
          {{ error }}
        </div>

        <div class="frame" style="text-align: left">
          <div class="fieldLabel">{{ _common.name }}</div>
          <div class="inputField">
            <input matInput formControlName="name" autofocus />
          </div>
          <div class="fieldLabel">{{ _common.email }}</div>
          <div class="inputField">
            <input
              matInput
              formControlName="email"
              #emailInput
              (change)="updateEmail($event)"
            />
          </div>
          <div
            *ngIf="
              form.controls['email'].touched && !form.controls['email'].valid
            "
            style="color: red; font-size: 11px; margin-top: 5px"
          >
            *{{ _common.email_error }}
          </div>

          <div class="fieldLabel">Referral Code</div>
          <div class="inputField">
            <input matInput formControlName="referreeCode" />
          </div>

          <div class="fieldLabel">{{ _common.Phone }}</div>
          <div class="inputField">
            <input matInput formControlName="phone" />
          </div>
          <div
            *ngIf="phone.invalid && (phone.dirty || phone.touched)"
            style="color: red; font-size: 11px; margin-top: 5px"
          >
            *{{ _common.phone_error }}
          </div>

          <div class="fieldLabel">{{ _common.CompanyName }}</div>
          <div class="inputField">
            <input matInput formControlName="accountName" />
          </div>

          <div style="display: flex; width: 100%">
            <!-- <div style="width: 49%; margin-right: 2%;">
                     <div class="fieldLabel">{{_common.username}}
                     </div>
                     <div class="inputField">
                        <input matInput formControlName="username" autocomplete="false">
                     </div>
                  </div> -->

            <div style="width: 49%">
              <div class="fieldLabel">{{ _common.pw }}</div>
              <div class="inputField">
                <input
                  matInput
                  id="password"
                  formControlName="password"
                  [type]="type"
                  autocomplete="false"
                  #passwordInput
                />
                <span (click)="togglePassword()" style="cursor: pointer">
                  <ng-container *ngIf="type == 'password'">
                    <fa-icon icon="eye-slash"></fa-icon>
                  </ng-container>
                  <ng-container *ngIf="type != 'password'">
                    <fa-icon icon="eye"></fa-icon>
                  </ng-container>
                </span>
              </div>
              <div
                *ngIf="password.invalid && (password.dirty || password.touched)"
                style="color: red; font-size: 11px; margin-top: 5px"
              >
                *{{ _common.pw_error }}
              </div>
            </div>
          </div>

          <div class="fieldLabel" style="margin-top: 2rem">
            {{ _common.SetUrl }}
          </div>

          <div style="display: flex; align-items: baseline; margin-top: 10px">
            <div style="margin-right: 5px">https://</div>
            <div class="inputField" style="width: 1 1 auto">
              <input matInput formControlName="domain" placeholder="domain" />
            </div>
            <div style="margin-left: 5px">.thinkshops.io</div>
          </div>
          <div
            *ngIf="domain.invalid && (domain.dirty || domain.touched)"
            style="color: red; font-size: 11px; margin-top: 5px"
          >
            *{{ _common.domain_error }}
          </div>

          <div (click)="proceed()" class="button">
            {{ _common.signup }}
          </div>
          <div style="text-align: center">
            <a style="color: #1ca0da" [href]="'/?app=' + app">{{
              _common.BackToLogin
            }}</a>
          </div>
        </div>

        <div
          style="
            display: flex;
            justify-content: center;
            align-items: baseline;
            margin: 20px 0px;
            color: white;
            font-size: 13px;
          "
        >
          <div style="margin-right: 10px">{{ _common.language }}:</div>
          <div
            (click)="changeLang('en')"
            style="
              text-decoration: underline;
              cursor: pointer;
              margin-right: 15px;
            "
          >
            English
          </div>
          <div
            (click)="changeLang('zh_hk')"
            style="text-decoration: underline; cursor: pointer"
          >
            中文(繁)
          </div>
        </div>

        <!--<div class="frame">
            <div>
               <mat-form-field appearance="outline" style="width:100%">
                  <mat-label>Email</mat-label>
                  <input matInput formControlName="email" #emailInput autofocus (change)="updateEmail($event)">
               </mat-form-field>
            </div>
   
            <div>
               <mat-form-field appearance="outline" style="width:100%">
                  <mat-label>Your Name</mat-label>
                  <input matInput formControlName="name">
               </mat-form-field>
            </div>
   
            <div>
               <mat-form-field appearance="outline" style="width:100%">
                  <mat-label>Company Name</mat-label>
                  <input matInput formControlName="accountName">
               </mat-form-field>
            </div>
   
            <div style="display:flex; align-items: center; width:100%">
               <mat-form-field appearance="outline" style="flex: 1 1 auto">
                  <mat-label>User Name</mat-label>
                  <input matInput formControlName="username">
               </mat-form-field>
               <div style="margin-left:10px; margin-right:10px;">@</div>
               <mat-form-field appearance="outline" style="flex: 1 1 auto">
                  <mat-label>Domain</mat-label>
                  <input matInput formControlName="domain">
               </mat-form-field>
   
            </div>
   
   
            <div>
               <mat-form-field appearance="outline" style="width:100%">
                  <mat-label>Password</mat-label>
                  <input matInput id="password" formControlName="password" type="password">
               </mat-form-field>
               <div *ngIf="password.invalid && (password.dirty || password.touched)" style="color:red; font-size:11px">
                  *Password must be at least 6 characters including capital letter and number
               </div>
            </div>

            <div (click)="proceed()" class="button">
               Signup
            </div>
            <div>
               <a style="color:#1CA0DA;" href="/">Back to Login</a>
            </div>

         </div>-->
      </form>
    </div>
  </div>
</div>
<!--<div style="position:absolute; bottom:0px; left:0px; right:0px; z-index:-1">
   <img src="/apps/signup_bg.svg" width="100%">
</div>-->
